import {
  base_colorContentBorder,
  base_colorSurfaceSecondary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { font_md, fontH2, fontH3 } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  .BaseModal-Content.interactive {
    width: min(750px, calc(100vw - ${spacing(12)}));
  }

  &.GoogleWorkspaceIntegrationSetupModal .BaseModal-Body {
    display: grid;
    gap: ${spacing(6)};
    padding: ${spacing(10)};
  }

  h1 {
    ${fontH2};
  }

  .GoogleWorkspaceIntegrationSetupModal-layout {
    display: grid;
    grid-template-columns: minmax(180px, 1fr) minmax(0, 2fr);
    gap: ${spacing(8)};
  }

  .GoogleWorkspaceIntegrationSetupModal-content {
    display: grid;
    align-content: start;
    gap: ${spacing(5)};
    min-width: 0;
  }

  .GoogleWorkspaceIntegrationSetupModal-content h2 {
    ${fontH3};
  }

  .GoogleWorkspaceIntegrationSetupModal-content p,
  .GoogleWorkspaceIntegrationSetupModal-content li {
    ${font_md};
  }

  .GoogleWorkspaceIntegrationSetupModal-content ul {
    display: grid;
    gap: ${spacing(3)};
    padding-inline-start: ${spacing(6)};
  }

  .GoogleWorkspaceIntegrationSetupModal-field {
    display: grid;
    gap: ${spacing(2)};
  }

  .GoogleWorkspaceIntegrationSetupModal-field > span {
    min-height: 20px;
    color: ${text_colorTextSecondary};
  }

  .GoogleWorkspaceIntegrationSetupModal-code {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: center;
    gap: ${spacing(4)};
    padding: ${spacing(4)};
    border: 1px solid ${base_colorContentBorder};
    background: ${base_colorSurfaceSecondary};
  }

  .GoogleWorkspaceIntegrationSetupModal-code code {
    overflow-wrap: anywhere;
  }

  .GoogleWorkspaceIntegrationSetupModal-code--scope {
    grid-template-columns: minmax(0, 1fr);
  }

  .GoogleWorkspaceIntegrationSetupModal-code--scope > button {
    justify-self: end;
  }

  .GoogleWorkspaceIntegrationSetupModal-actions {
    display: flex;
    justify-content: flex-end;
    gap: ${spacing(3)};
  }

  .GoogleWorkspaceIntegrationSetupModal-success {
    display: grid;
    gap: ${spacing(4)};
  }

  @media (max-width: 768px) {
    .GoogleWorkspaceIntegrationSetupModal-layout {
      grid-template-columns: minmax(0, 1fr);
    }
  }
`
